import { InputIcon } from '@platform/ui-library';
import {
  FC,
  SyntheticEvent,
  useLayoutEffect,
  useRef
} from 'react';
import { FormField, Input, InputFieldType } from '@app/form_components';
import { useObjectForm } from '@app/hooks';

export type NodeHeaderProps = {
  getControlProps: ReturnType<typeof useObjectForm>['getControlProps'];
};

export const NodeHeader: FC<NodeHeaderProps> = ({
  getControlProps
}) => {
  const labels = window.l.property;
  const { error: nameFieldError, ...nameField } = getControlProps('name');
  const wrapperRef = useRef<HTMLDivElement>(null);
  const cursorPosRef = useRef<number | null>(null);

  useLayoutEffect(() => {
    if (cursorPosRef.current == null) {
      return;
    }
    const input = wrapperRef.current?.querySelector('input');
    if (input) {
      input.setSelectionRange(cursorPosRef.current, cursorPosRef.current);
    }
    cursorPosRef.current = null;
  });

  return (
    <>
      <div ref={wrapperRef}>
        <FormField error={nameFieldError} label={labels.name}>
          <InputIcon
            {...nameField}
            onChange={(event: SyntheticEvent<HTMLInputElement>) => {
              const fullRawValue = event.currentTarget.value;
              const rawCursor = event.currentTarget.selectionStart ?? fullRawValue.length;
              const applyTransform = (rawValue: string) => (
                rawValue
                .toUpperCase()
                .replace(/\s+/g, '_')
                .replace(/^[^A-Z]+|[^A-Z0-9_]/g, '')
                .replace(/__+/g, '_')
              );
              cursorPosRef.current = applyTransform(fullRawValue.slice(0, rawCursor)).length;
              nameField.onChange(applyTransform(fullRawValue));
            }}
            value={nameField.value ?? ''}
          />
        </FormField>
      </div>
      <Input
        {...getControlProps('description')}
        label={labels.description}
        type={InputFieldType.textarea}
      />
      <hr />
    </>
  );
};
